import styled from 'styled-components';

const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundReverse};
  color: ${({ theme }) => theme.colors.textReverse};
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
`;

export default Card;